import { AvatarContainerStyleInterface } from "./avatar_container_interfaces";

export const avatarContainerDefaultStyle: AvatarContainerStyleInterface = {
    size: "10",
    textColor: "white",
    backgroundColor: "primary",
};
